import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { StyledRewardPointCost } from './reward-point-cost.styled';
import { IRewardPointCost } from './types';

export const RewardPointCost: FC<IRewardPointCost> = ({ pointCost, usePrimaryColor, children }) => {
  const { formatMessage } = useIntl();

  return pointCost === 0 ? (
    <StyledRewardPointCost usePrimaryColor={usePrimaryColor}>
      {formatMessage({ id: 'free' }).toLocaleLowerCase()}
    </StyledRewardPointCost>
  ) : (
    <>{children}</>
  );
};
